// Stockists Section JavaScript
document.addEventListener("DOMContentLoaded", function () {
  const filterPills = document.querySelectorAll(".filter-pill");
  const stockistCards = document.querySelectorAll(".stockist-card");
  const viewAllButton = document.getElementById("viewAllButton");
  let allCardsVisible = false;

  // Initialize filtering
  function filterStockists(country) {
    stockistCards.forEach((card) => {
      const cardCountry = card.getAttribute("data-country");

      if (country === "all" || cardCountry === country) {
        // Show cards based on view all state
        if (allCardsVisible || !card.classList.contains("hidden-by-default")) {
          card.classList.remove("hidden");
          card.style.animation = "fadeInUp 0.3s ease-out";
        }
      } else {
        card.classList.add("hidden");
      }
    });
  }

  // Show all cards function
  function showAllCards() {
    stockistCards.forEach((card) => {
      card.classList.remove("hidden-by-default");
      card.classList.remove("hidden");
      card.style.animation = "fadeInUp 0.3s ease-out";
    });
    allCardsVisible = true;

    // Hide the view all button
    if (viewAllButton) {
      viewAllButton.classList.add("hidden");
    }
  }

  // Add click event listeners to filter pills
  filterPills.forEach((pill) => {
    pill.addEventListener("click", function () {
      const country = this.getAttribute("data-country");

      // Update active state
      filterPills.forEach((p) => p.classList.remove("active"));
      this.classList.add("active");

      // Filter stockists
      filterStockists(country);
    });
  });

  // Add click event listener to view all button
  if (viewAllButton) {
    viewAllButton.addEventListener("click", showAllCards);
  }

  // Initialize with first 9 stockists visible
  filterStockists("all");
});
